<template lang="pug">
  .page-404(v-if="true")
    .page-404__bg-down-wr
        .page-404__bg-down
    .page__wr.page-404__wr
      ul.page-404__nav
        li.page-404__nav-item
          router-link(to="/") Главная
        li.page-404__nav-item.page-404__nav-item--active
          router-link(to="*") ...
      h2.page-404__headline Вернтуться на главную
      .page-404__content
        .page-404__content-block
            h1.page-404__content-block-title 404
            .page-404__content-block-container
                .page-404__content-block-headline Извините!
                .page-404__content-block-headline страница не найдена
        router-link.page-404__content-link(to="/") вернуться на главную
      .page-404__bg-up-wr
        .page-404__bg-up
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/page404/page404.styl';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';

  // @ is an alias to /src
  //import Footer from '@/components/common/footer/Footer.vue';

  export default {
    name: 'About',

    mixins: [AjaxHelpersVue],

    data() {
      return {

      }
    },

    components: {
      //Footer
    },

    created() {
      // Загрузка данных для страницы
        this.$nextTick(() => {
            // this.request(this.$router.currentRoute.path);
        });
    },

    beforeRouteEnter(to, from, next) {
      next(vm => {
          // экземпляр компонента доступен как `vm`
          EventBus.$emit('pagePreloaderShow');
          vm.scrollbarCheck();
          setTimeout(() => {
              EventBus.$emit('setMenuTopActiveClass', to.path);
              vm.request(to.path);
          }, 50);
      })
    },

    beforeRouteUpdate(to, from, next) {
        EventBus.$emit('pagePreloaderShow');
        this.scrollbarCheck();
        setTimeout(() => {
            EventBus.$emit('setMenuTopActiveClass', to.path);
            this.request(to.path);
            next();
        }, 50);
    },

    methods: {
      request() {
        // Нейминг должен быть такой, без цифр в начале
        this.req('NotFoundPage:getNotFoundPage', {url: '/*'}, res => {
            this.content = res.content;
            EventBus.$emit('pagePreloaderHide');
            this.$nextTick(() => {
                this.checkOverflow(this.$router.currentRoute.path);
                let src = ['/img/background.png', '/img/background-big.png'];
                let $img1 = $('<img src="' + src[0] + '">');
                let $img2 = $('<img src="' + src[1] + '">');
                $img1.bind( 'load', function(){
                    $('.page-404__bg-down-wr').css({'background-image': 'url(' + src[0] + ')', 'opacity': '1'} );
                });
                $img2.bind( 'load', function(){
                    $('.page-404__bg-up').css({'background-image': 'url(' + src[1] + ')', 'opacity': '1'} );
                });
                if( $img1[0].width && $img2[0].width ){ $img1.trigger( 'load' ); $img2.trigger( 'load' ); }
            });
        });
      }
    }
  }
</script>
